import { ToastContainer, toast } from 'react-toastify';
import { generateLog } from '../constants/Logger'

export const showToastSuccess = (message) => {
    toast.success(message);
};

export const showToastError = (message) => {
    generateLog('default',showToastError.name,'Error Toast Mesage : ',message);
    toast.error(message);
};

export const showToastWarning = (message) => {
    generateLog('default',showToastWarning.name,'Warning Toast Mesage : ',message);
    toast.warning(message);
};